import { AxiosError } from "axios";
import { ErrorPageProps } from "../../@types/Rd";
import { isEmptyObject } from "jquery";

const HandleAxiosException = (errorCode: number, exception: AxiosError<any, any> | undefined = undefined): { Message: string, Code: number } | undefined => {
    if (exception != null && !isEmptyObject(exception)) {

        const { response, message } = exception,
            result: { Message: string, Code: number } = { Message: response?.data || DefaultResponse.get(errorCode)!, Code: errorCode };

        if (message == "canceled")
            result.Message = "Requisição cancelada."

        if (message == "Request failed with status code 400") {

            result.Code = response?.status || errorCode || 400;
            result.Message = "O request da requisição esta causando erro.";

            if (response?.data?.errors != null && !isEmptyObject(response.data.errors)) {

                const errors = response.data.errors[""]
                    || Object.entries(response.data.errors)
                        .map(([key, messages]) => `${key} ${((messages || []) as string[]).join('\n')}`);

                if (errors != null && typeof errors == 'string')
                    result.Message = errors;

                if (Array.isArray(errors))
                    result.Message = ((errors || []) as string[]).join('\n');
            }
        }

        return result;
    }
}

export const DefaultErrorCode: number = 500;
export const DefaultResponse: Map<number, string> = new Map(
    [
        [401, "Você não esta autorizado a ver isso."],
        [403, "Você não esta autorizado a ver isso."],
        [404, "Pagina não encontrada!!"],
        [418, "🫖"],
        [500, "Algo deu errado, tente novamente mais tarde."],
        [503, "Aparentemente a API esta fora do ar."]
    ]);

export interface IErrorModel {
    ErrorCode?: number,
    CustomMessage?: string

    ToPageProps: () => ErrorPageProps
}


export default class ErrorModel implements IErrorModel {
    ErrorCode?: number | undefined;
    CustomMessage?: string | undefined;

    constructor(customMessage: string | undefined = undefined, errorCode: number = DefaultErrorCode, exception: AxiosError<any, any> | undefined = undefined) {
        const handled = HandleAxiosException(errorCode, exception);
        this.ErrorCode = handled?.Code || errorCode;
        this.CustomMessage = handled?.Message || customMessage;
    }

    ToPageProps = (): ErrorPageProps => {
        const result: ErrorPageProps = {
            customMessage: this.CustomMessage,
            errorCode: this.ErrorCode
        }

        return result;
    }
}